<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '../utils'
import { useAttachmentContext } from './context'
import { getAttachmentLabel } from './utils'

interface Props {
  class?: HTMLAttributes['class']
  showMediaType?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showMediaType: false,
})

const { data, variant } = useAttachmentContext()
const label = computed(() => getAttachmentLabel(data.value))
</script>

<template>
  <div
    v-if="variant !== 'grid'"
    :class="cn('min-w-0 flex-1', props.class)"
    v-bind="$attrs"
  >
    <span class="block truncate text-gray-900 dark:text-gray-100">{{
      label
    }}</span>
    <span
      v-if="props.showMediaType && data.mediaType"
      class="block truncate text-xs text-gray-500 dark:text-gray-400"
    >
      {{ data.mediaType }}
    </span>
  </div>
</template>
